import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../reducers';
import { getEventsFromStateFromPath } from '../../helpers';
import { loadEvents, loadPracticeEvent } from '../actions';

export const useEventsState = (onlyDatePath: string) => {
  return useSelector((state: RootState) => {
    return getEventsFromStateFromPath(state, onlyDatePath);
  });
};

export const useEventsDispatch = () => {
  const dispatch = useDispatch();
  return {
    loadEvents: (priority: boolean, live?: boolean, backgroundReplace?: boolean, isSync?:boolean, isMobile?:boolean, createAndGo?:()=> void) => () => {
      dispatch(loadEvents(priority, live, backgroundReplace, null, isSync, isMobile, createAndGo));
    },
    loadPracticeEvent: (gameId: string) => () => {
      dispatch(loadPracticeEvent(gameId));
    },
  };
};
